import { Injectable } from '@angular/core';

import { BaasEditSaveOptions, BaasEditSaveResult } from './baas-edit.types';
/** BaaS Edit service to be provided by the component implementing BaaS Edit. */
@Injectable()
export class BaasEditService {
    _saveRequested: (value: { options: BaasEditSaveOptions; resolve: (value: BaasEditSaveResult) => void }) => void;

    /** Requests a save by first performing validation and checks and completes when terminated. */
    requestSave(options: BaasEditSaveOptions = undefined): Promise<BaasEditSaveResult> {
        if (options == null) options = { reason: 'custom' };
        if (options.reason == null) options.reason = 'custom';
        return new Promise<BaasEditSaveResult>((resolve) => this._saveRequested({ options, resolve }));
    }
}
